module.exports = __webpack_public_path__ + "static/media/2.458d959d.jpg";